// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["themes/default/css/style","themes/default/css/app"], () => (__webpack_require__("./resources/themes/default/js/app.js")))
__webpack_require__.O(undefined, ["themes/default/css/style","themes/default/css/app"], () => (__webpack_require__("./resources/themes/default/sass/app.scss")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["themes/default/css/style","themes/default/css/app"], () => (__webpack_require__("./resources/themes/default/sass/style.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
